import React, { useState } from 'react';
import { Modal, Input } from 'antd';
import { HistoryColor } from 'services/store/enums/historyColor.enum';
import { IOrder } from 'services/store/types/orders/Orders';

interface IProps {
  order: IOrder;
  closeModal: () => void;
  handleUpdateOrder: (
    updateData: Partial<IOrder>,
    historyUpdate: string[],
    historyColor: HistoryColor
  ) => Promise<any>;
}

const ChangeOrderNameModal: React.FC<IProps> = ({
  order,
  closeModal,
  handleUpdateOrder,
}) => {
  const [name, setName] = useState<string>(order.name);

  const onOk = async () => {
    const historyUpdate = [
      `Zaktualizowano nazwę zamówienia:`,
      `${order.name} na ${name}`,
    ];
    await handleUpdateOrder({ name }, historyUpdate, HistoryColor.SUCCESS);
    closeModal();
  };

  return (
    <Modal
      title="Zmiana nazwy zamówienia"
      destroyOnClose
      visible
      onCancel={closeModal}
      maskClosable={false}
      onOk={onOk}
    >
      <Input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Nazwa zamówienia"
        style={{ width: '100%' }}
      />
    </Modal>
  );
};

export default ChangeOrderNameModal;
